import { DependencyList, useEffect } from 'react'

/* How to use:
 * import useEventListeners from 'hooks/eventListener'
 * useEventListeners({ scroll: onScroll })
*/

type MappedEventsToHandlers = {
  [key in keyof WindowEventMap as string]: () => void
}

const useEventListeners = (
  mappedEventsToHandlers: MappedEventsToHandlers,
  dependencies?: DependencyList | undefined,
) => {
  useEffect(() => {
    Object.keys(mappedEventsToHandlers).forEach(event => {
      window.addEventListener(event, mappedEventsToHandlers[event])
    })

    return () => {
      Object.keys(mappedEventsToHandlers).forEach(event => {
        window.removeEventListener(event, mappedEventsToHandlers[event])
      })
    }
  }, dependencies)
}

export default useEventListeners
